/** Choice display settings shared by authored questions and respondent projections. */
export interface ChoicePresentationField {
  choicePresentation?: 'auto' | 'list' | 'dropdown';
  options?: readonly unknown[];
  rating?: unknown;
}

/** Resolves the choice control presentation without changing its answer semantics. */
export function resolveChoicePresentation(field: ChoicePresentationField): 'list' | 'dropdown' {
  if (field.rating) return 'list';
  if (field.choicePresentation === 'list' || field.choicePresentation === 'dropdown') return field.choicePresentation;
  return (field.options?.length ?? 0) >= 6 ? 'dropdown' : 'list';
}
